import React from 'react';

const ThemeConfigurationPanel = ({ theme, handleChange }) => {
    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-sliders"></i>
                    Theme Configuration
                </span>
            </div>
            <div className="notifications-panel__body">
                {/* Theme Mode */}
                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">Theme Mode</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="form-label">Mode</label>
                            <select
                                className="form-control"
                                value={theme.theme.mode}
                                onChange={(e) => handleChange('theme', null, 'mode', e.target.value)}
                            >
                                <option value="light">Light</option>
                                <option value="dark">Dark</option>
                                <option value="auto">Auto</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Color Palette */}
                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">Color Palette</h6>
                    <div className="row">
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Primary</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.primary}
                                    onChange={(e) => handleChange('theme', 'colors', 'primary', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.primary}
                                    onChange={(e) => handleChange('theme', 'colors', 'primary', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Primary Light</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.primaryLight}
                                    onChange={(e) => handleChange('theme', 'colors', 'primaryLight', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.primaryLight}
                                    onChange={(e) => handleChange('theme', 'colors', 'primaryLight', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Primary Dark</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.primaryDark}
                                    onChange={(e) => handleChange('theme', 'colors', 'primaryDark', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.primaryDark}
                                    onChange={(e) => handleChange('theme', 'colors', 'primaryDark', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Secondary</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.secondary}
                                    onChange={(e) => handleChange('theme', 'colors', 'secondary', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.secondary}
                                    onChange={(e) => handleChange('theme', 'colors', 'secondary', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Secondary Light</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.secondaryLight}
                                    onChange={(e) => handleChange('theme', 'colors', 'secondaryLight', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.secondaryLight}
                                    onChange={(e) => handleChange('theme', 'colors', 'secondaryLight', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Success</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.success}
                                    onChange={(e) => handleChange('theme', 'colors', 'success', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.success}
                                    onChange={(e) => handleChange('theme', 'colors', 'success', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Info</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.info}
                                    onChange={(e) => handleChange('theme', 'colors', 'info', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.info}
                                    onChange={(e) => handleChange('theme', 'colors', 'info', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Warning</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.warning}
                                    onChange={(e) => handleChange('theme', 'colors', 'warning', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.warning}
                                    onChange={(e) => handleChange('theme', 'colors', 'warning', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Danger</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.danger}
                                    onChange={(e) => handleChange('theme', 'colors', 'danger', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.danger}
                                    onChange={(e) => handleChange('theme', 'colors', 'danger', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Light</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.light}
                                    onChange={(e) => handleChange('theme', 'colors', 'light', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.light}
                                    onChange={(e) => handleChange('theme', 'colors', 'light', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Dark</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.dark}
                                    onChange={(e) => handleChange('theme', 'colors', 'dark', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.dark}
                                    onChange={(e) => handleChange('theme', 'colors', 'dark', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Background</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.background}
                                    onChange={(e) => handleChange('theme', 'colors', 'background', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.background}
                                    onChange={(e) => handleChange('theme', 'colors', 'background', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Surface</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.surface}
                                    onChange={(e) => handleChange('theme', 'colors', 'surface', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.surface}
                                    onChange={(e) => handleChange('theme', 'colors', 'surface', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Text</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.text}
                                    onChange={(e) => handleChange('theme', 'colors', 'text', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.text}
                                    onChange={(e) => handleChange('theme', 'colors', 'text', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Text Muted</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.textMuted}
                                    onChange={(e) => handleChange('theme', 'colors', 'textMuted', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.textMuted}
                                    onChange={(e) => handleChange('theme', 'colors', 'textMuted', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted">Border</label>
                            <div className="input-group input-group-sm">
                                <input
                                    type="color"
                                    className="form-control form-control-color"
                                    value={theme.theme.colors.border}
                                    onChange={(e) => handleChange('theme', 'colors', 'border', e.target.value)}
                                    style={{ width: '40px' }}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    value={theme.theme.colors.border}
                                    onChange={(e) => handleChange('theme', 'colors', 'border', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Typography */}
                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">Typography</h6>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="form-label">Small</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.theme.fonts.size.small}
                                onChange={(e) => handleChange('theme', 'fonts', 'size', {...theme.theme.fonts.size, small: e.target.value})}
                            />
                            <small className="text-muted">Accepts px, rem</small>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Base</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.theme.fonts.size.base}
                                onChange={(e) => handleChange('theme', 'fonts', 'size', {...theme.theme.fonts.size, base: e.target.value})}
                            />
                            <small className="text-muted">Accepts px, rem</small>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Large</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.theme.fonts.size.large}
                                onChange={(e) => handleChange('theme', 'fonts', 'size', {...theme.theme.fonts.size, large: e.target.value})}
                            />
                            <small className="text-muted">Accepts px, rem</small>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">XL</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.theme.fonts.size.xl}
                                onChange={(e) => handleChange('theme', 'fonts', 'size', {...theme.theme.fonts.size, xl: e.target.value})}
                            />
                            <small className="text-muted">Accepts px, rem</small>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label className="form-label">Border Radius</label>
                            <input
                                type="text"
                                className="form-control"
                                value={theme.theme.borderRadius}
                                onChange={(e) => handleChange('theme', null, 'borderRadius', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThemeConfigurationPanel;
